import { AccountRecord } from '../../../../api/client'
import { ShadowBannedProfilesTable } from './ShadowBannedProfilesTable'
import ShadowBanningSettingsSummary from './ShadowBanningSettingsSummary'

export function ShadowBanningSettings({ account }: { account: AccountRecord }) {
    return (
        <>
            <div className="space-y-4">
                <ShadowBanningSettingsSummary account={account} />

                <ShadowBannedProfilesTable account={account} />
            </div>
        </>
    )
}
